import React, { useMemo } from "react";
import PropTypes from "prop-types";
import filter from "lodash/filter";
import find from "lodash/find";
import map from "lodash/map";
import toLower from "lodash/toLower";
import MultipleAnimations from "components/games/elements/GenericGame/MultipleAnimations";

export default function DefaultPodium(props) {
    const {
		clinicData,
	    config,
    } = props;

	const getFrames = (animation) => {
        let framesList = [];
        for (let i = 0; i < animation.frameCount; i++) {
            const row = Math.floor(i / animation.frameColumns);
            const frameRows = Math.ceil(animation.frameCount / animation.frameColumns);
            framesList.push({
                height: animation.imageHeight,
                left: `-${((animation.imageWidth / animation.frameColumns) * i) % animation.imageWidth}px`,
                top: `-${row * (animation.imageHeight / frameRows)}px`,
                width: animation.imageWidth,
            });
        }
        return framesList;
    };

	if (!config?.animationOptions?.length) {
		return null;
	}

	const getAnimationIndex = () => {
        const currentAnimation = find(config.animationIndexes, a => {
            let keep = true;
            if (a.avatarType) {
                if (keep) {
                    keep = toLower(clinicData?.AvatarType);
                }
            }
            return keep;
        });
        return currentAnimation?.animationIndex || 0;
    };

	const getAnimations = () => {
        if (!!getAnimationIndex) {
            // This is used to get an animation based on a certain piece of data. It returns the index of the animation.
            const index = getAnimationIndex();
            if (!animationOptions?.[index]) {
                console.error("The index", index, "doesn't exist:", animationOptions);
                return animationOptions[0];
            }
            return animationOptions[index];
        } else {
            // By default, return only the first animation
            return 0;
        }
    };

	const animationOptions = useMemo(() => {
        return map(config.animationOptions, ao => ({
                ...ao,
                animations: map(ao.animations, a => ({
                    ...a,
                    frames: getFrames(a),
                })),
            })
        );
    }, [config]);

	const filteredAnimations = useMemo(() => {
        const animations = getAnimations();
        return filter(animations?.animations, a => {
            let canView = a.canView || false;
            if (!!a.getCanView) {
                canView = a.getCanView();
            }
            return canView;
        });
    }, [animationOptions, clinicData]);

    return (
		<div
			className="position-relative"
			style={{ minHeight: filteredAnimations?.[0]?.height || "250px" }}
		>
			<MultipleAnimations animations={filteredAnimations} readyToAnimate />
		</div>
    );
}

DefaultPodium.propTypes = {
	clinicData: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
};
